import React from 'react';
import './calendrier.css';
import { Footer, Header } from '../index';
import calendrier from '../../asserts/images/calendrier.jpg';
import { Link } from 'react-router-dom';

function Calandrier(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header />
      <div className='containerINFO'>
        <div className='introrg'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-130px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy'}}className="container-fluid text-white text-center ">Calandrier Universitaire</h1>
          <p className="container-fluid text-white text-center" ><Link className='linkorg' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkorg'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkorg'
            to="/">Calandrier</Link> </p></div>
      </div>
      <div className='calendrier'>
      <img src={calendrier} className="org4" alt="organigramme" />

      </div>
     
      
      <Footer />
    </div>
  )
}

export default Calandrier;
 /*<a target="_blank" href="/images/organigramme.jpg">
    </a>*/